// === Импорти ===
import Vue from "vue";
import Router from "vue-router";
import { getUser } from "@/services/db";

// === Layout-и ===
import AuthLayout from "@/layouts/AuthLayout.vue";
import ClientLayout from "@/layouts/ClientLayout.vue";
import VrabotenLayout from "@/layouts/VrabotenLayout.vue";

// === Јавни страници (Најави) ===
import NajavaIzbor from "@/pages/NajavaIzbor.vue";
import Najava from "@/pages/Najava.vue";
import NajavaKlient from "@/pages/NajavaKlient.vue";

// === Клиентски страници ===
import NovoBaranje from "@/pages/klient/NovoBaranje.vue";
import MoiteBaranja from "@/pages/klient/MoiteBaranja.vue";
import PreglediKlient from "@/pages/klient/Pregledi.vue";

// === Вработен страници (постоечки) ===
import Pregledi from "@/pages/vraboten/Pregledi.vue";
//import FaziBaranje from "@/pages/vraboten/FaziBaranje.vue";
import TelefonskiPovici from "@/pages/vraboten/TelefonskiPovici.vue";
//import Sifrarnici from "@/pages/vraboten/Sifrarnici.vue";
import Izvestai from "@/pages/vraboten/Izvestai.vue";
import Podesuvanja from "@/pages/vraboten/Podesuvanja.vue";
//import Izvestuvanja from "@/pages/vraboten/Izvestuvanja.vue";
//import Korisnici from "@/pages/vraboten/Korisnici.vue";

// === Активирање на Router ===
Vue.use(Router);

// === Помошна функција — нормализација на улога ===
function normalizeRole(role) {
  if (!role) return "";
  const r = (role + "").toLowerCase().trim().replace(/[\s\-_]/g, "");
  const map = {
    klient: "Klient",
    vraboten: "Vraboten",
    клиент: "Klient",
    вработен: "Vraboten",
  };
  return map[r] || role;
}

// === Рути ===
const router = new Router({
  mode: "history",
  scrollBehavior(to, from, saved) {
    if (saved) return saved;
    return { x: 0, y: 0 };
  },
  routes: [
    // === Јавни страници ===
    {
      path: "/najava",
      component: AuthLayout,
      children: [
        {
          path: "",
          name: "NajavaIzbor",
          component: NajavaIzbor,
          meta: { public: true },
        },
      ],
    },
    {
      path: "/najava-vraboten",
      component: AuthLayout,
      children: [
        {
          path: "",
          name: "NajavaVraboten",
          component: Najava,
          meta: { public: true },
        },
      ],
    },
    {
      path: "/najava-klient",
      component: AuthLayout,
      children: [
        {
          path: "",
          name: "NajavaKlient",
          component: NajavaKlient,
          meta: { public: true },
        },
      ],
    },

    // === Клиентски интерфејс ===
    {
      path: "/klient",
      component: ClientLayout,
      children: [
        { path: "", redirect: "moite-baranja" },
        {
          path: "moite-baranja",
          name: "MoiteBaranja",
          component: MoiteBaranja,
          meta: { role: ["Klient"] },
        },
        {
          path: "novo-baranje",
          name: "NovoBaranje",
          component: NovoBaranje,
          meta: { role: ["Klient"] },
        },
        {
          path: "pregledi",
          name: "PreglediKlient",
          component: PreglediKlient,
          meta: { role: ["Klient"] },
        },
      ],
    },

    // === Вработен интерфејс ===
    {
      path: "/vraboten",
      component: VrabotenLayout,
      children: [
        { path: "", redirect: "pregledi" },

        //  ПРЕГЛЕДИ 
        {
          path: "pregledi",
          name: "Pregledi",
          component: Pregledi,
          meta: { role: ["Vraboten"] },
        },

        // === ОСТАНАТО (НЕ СЕ МЕНУВА)
        // {
        //   path: "fazi/:id",
        //   name: "FaziBaranje",
        //   component: FaziBaranje,
        //   props: true,
        //   meta: { role: ["Vraboten"] },
        // },
        {
          path: "telefonski-povici",
          name: "TelefonskiPovici",
          component: TelefonskiPovici,
          meta: { role: ["Vraboten"] },
        },
        // {
        //   path: "sifrarnici",
        //   name: "Sifrarnici",
        //   component: Sifrarnici,
        //   meta: { role: ["Vraboten"] },
        // },
        {
          path: "azuriranje-nalozi",
          name: "AzuriranjeNalozi",
          component: () => import("@/pages/vraboten/AzuriranjeNalozi.vue"),
          meta: { role: ["Vraboten"] },
        },
        // {
        //   path: "servisi",
        //   name: "Servisi",
        //   component: () => import("@/pages/vraboten/Servisi.vue"),
        //   meta: { role: ["Vraboten"] },
        // },
        {
          path: "izvestai",
          name: "Izvestai",
          component: Izvestai,
          meta: { role: ["Vraboten"] },
        },
        // {
        //   path: "izvestuvanja",
        //   name: "Izvestuvanja",
        //   component: Izvestuvanja,
        //   meta: { role: ["Vraboten"] },
        // },
        // {
        //   path: "korisnici",
        //   name: "Korisnici",
        //   component: Korisnici,
        //   meta: { role: ["Vraboten"] },
        // },
        {
          path: "podesuvanja",
          name: "Podesuvanja",
          component: Podesuvanja,
          meta: { role: ["Vraboten"] },
        },
        {
          path: "pregledi/po-fazi",
          name: "PoFazi",
          component: () => import("@/pages/vraboten/PoFazi.vue"),
          meta: { role: ["Vraboten"] },
        },
        
      ],
    },

    // === Default redirect ===
    { path: "*", redirect: "/najava" },
  ],
});

// === Guard за контрола на пристап (Login / Roles) ===
router.beforeEach((to, from, next) => {
  const user = getUser?.() || null;

  if (to.meta.public) return next();

  if (!user) {
    if (to.path.startsWith("/vraboten")) {
      console.warn(" DEV MODE: симулирана најава за вработен");
      localStorage.setItem(
        "user",
        JSON.stringify({
          username: "dev.vraboten",
          ime: "Тест Вработен",
          uloga: "Vraboten",
        })
      );
      return next();
    }
    return next("/najava");
  }

  const role = normalizeRole(user.uloga);

  if (to.meta.role && !to.meta.role.includes(role)) {
    if (role === "Klient") return next("/klient/moite-baranja");
    if (role === "Vraboten") return next("/vraboten/pregledi");
    return next("/najava");
  }

  next();
});

export default router;

